import React from "react";
import MainLoader from '../../icons/MainLoader/MainLoader'
import useComebackPageLogic from './hooks/useCombackPageLogic'


const ComebackPage = () => {
    const WAITING_SCREEN_TEXT = "Daj nam chwilę" // Na tym etapie nie mamy jeszcze załadowanych tekstów z backendu
    useComebackPageLogic()

    return <MainLoader headingText={ WAITING_SCREEN_TEXT } />
}

export default ComebackPage;